(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.DialogAddMod_Handler = (function(superClass) {
    extend(DialogAddMod_Handler, superClass);

    function DialogAddMod_Handler() {
      DialogAddMod_Handler.__super__.constructor.call(this);
      this.makeId = null;
      this.isforcontroll = false;
      this.refreshNavHandler = false;
      this.modalOptions = {
        backdrop: 'static'
      };
    }

    DialogAddMod_Handler.prototype.init = function() {
      this.classes = 'smaller_dialog';
      if (this.isforcontroll) {
        this.layoutUrl = 'backend/grower/machinery/load-layout-addcomod';
      } else {
        this.layoutUrl = 'backend/grower/machinery/load-layout-addmod';
      }
      this.loadLayoutPostOptions = {
        makes_id: this.makeId
      };
      return this.createDialog();
    };

    DialogAddMod_Handler.prototype.afterLoadLayout = function() {
      return this.openDialog();
    };

    DialogAddMod_Handler.prototype.submitAction = function() {
      return this.save('Saving...');
    };

    return DialogAddMod_Handler;

  })(DialogHandler);

}).call(this);
